export default "__VITE_ASSET__CJNDWzrB__"